/** Saved calculations are guidance; they never replace an unknown work quantity. */
export function calculationGuide(work: {
  quantity: string | null;
  formula: Record<string, unknown> | null;
}): string | null {
  if (work.quantity !== null || !work.formula) return null;
  const parts = ['basis', 'explanation'].map(key => work.formula?.[key])
    .filter((value): value is string => typeof value === 'string' && !!value.trim());
  return parts.length ? [...new Set(parts)].join('\n\n') : null;
}
